import React, { useEffect, useState } from "react";
import { faMagnifyingGlass, faUser, faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation } from "react-router-dom";
import { serviceCall } from "../Utils/ServiceUtils";
import { Button, Form } from "react-bootstrap";

function Header() {
    const [cartDetails, setCartDetails] = useState([]);
    let location = useLocation();
    let content = JSON.parse(localStorage.getItem("Content"));
    let path = location.pathname.replace("/", "").toLowerCase();
    useEffect(() => {
        JSON.parse(localStorage.getItem("Content")) && getCartDetails();
    }, [])

    useEffect(() => {
        path = location.pathname.replace("/", "").toLowerCase();
        document.title = path.split("/")[0];
    }, [location.pathname])

    const getCartDetails = async () => {
        const resp = await serviceCall("GET", "/API/Cart/GetCartProducts");
        if (resp && !(resp.IsError === true)) {
            setCartDetails(resp);
            window.localStorage.setItem("CartDetails", JSON.stringify(resp));
        } else {
            window.localStorage.setItem("CartDetails", JSON.stringify([]));
        }
    }

    useEffect(() => {
        const cartEvtHandler = (e) => {
            if (e.key === "Cart" || (e.detail && e.detail.key === "Cart")) {
                setCartDetails(JSON.parse(localStorage.getItem("CartDetails")));
            }
        }
        window.addEventListener("storage", cartEvtHandler);
        return () => window.removeEventListener("storage", cartEvtHandler);
    }, []);
      
    //   const searchHandler = async (evt) => {
    //     if (evt.key === 'Enter') {
    //         evt.preventDefault();
    //         navigate(`/search/search${search}`);
    //     }
    // }

    return (
        <>
            {(path !== "login" && path !== "signup") ? <div className="containerHeader">
                <div className="logoCont" >
                    <Link to="/Home" style={{ textDecoration: "none", color: "rgb(33,37,41)" }}>
                        <span className="logoHeader"></span>
                    </Link>
                </div>
                <Form.Group className="searchBox d-flex" controlid="formBasicEmail">
                    <Form.Control
                        type="text"
                        placeholder="Search for anything"
                        className="inputSrch"
                        // onChange={(e) => setSearch(e.target.value)}
                        // onKeyDown={(e) => searchHandler(e)}
                    />
                    <div className="magnifySrch" >
                    <FontAwesomeIcon icon={faMagnifyingGlass}/></div>
                </Form.Group>
                <span className="d-flex userDetails">
                    {content ?
                        <>
                            <Link to="/cartDetails" className="shopcartIcon">
                                <FontAwesomeIcon className="" icon={faCartShopping} />
                            </Link></>
                        :
                        <>
                            <Link to="/Login" className="shopcartIcon">
                                <FontAwesomeIcon className="" icon={faCartShopping} />
                            </Link>
                        </>}
                    <span className="cartValue me-2">{cartDetails && cartDetails.length}</span>&nbsp;
                    <div className="loginPopover">
                        <FontAwesomeIcon className="" icon={faUser} style={{ textDecoration: "none", cursor: "pointer", color: "#F7921C", marginTop: "5px" }} />
                        <div className="popupOverLogin">
                            <div className="cart-btns">
                                <div style={{ color: "#2C2C2C", fontSize: "18px", paddingLeft: "15px", marginBottom: "10px" }}>Hello, {content && <span style={{ wordBreak: "break-all" }}>{content.UserName.split(" ")[0]}</span>}</div>
                                <Link to="/Login" style={{ textDecoration: "none", color: "#F7921C", left: "15px", position: "relative" }}>
                                    <Button className="btn l0gin" style={{ backgroundColor: "#1D4397", width: "86%" }}>{content ? "Logout" : "Login"}</Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </span>
            </div>: <div></div>}
        </>
    );
}

export default Header;